import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';

import { COLORS } from '../../../../utils/styles';

export const Wrapper = styled.div`
  text-align: left;
`;

export const Title = styled.h3`
  color: ${COLORS.slateGray};
  font-weight: 100;
  font-size: 19px;
  font-family: 'FiraSansUltraLight';
`;

export const LinksWrapper = styled.section`
  margin-top: 0px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  cursor: pointer;
`;

export const Left = styled(Col)`
  text-align: left;
`;

export const Right = styled(Col)`
  text-align: right;
`;

export const ButtonsWrappers = styled(Row)`
  margin: 1em 0px;
`;

// @TODO This color needs to be added to the overall style
export const StateDescription = styled.section`
  text-align: center;
  color: #363636;
  font-size: 0.9rem;
  max-width: 66%;
  margin-bottom: 1.5em;
`;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/ForgotPasswordBox/styled-components.js